// extracted by mini-css-extract-plugin
module.exports = {"footerAccordion":"FooterDropdown_footerAccordion__pCtuW"};